import type { HasAnnexPoints } from "../HasAnnexPoints.type"
import type { AnnexableEntityUnion } from "./AnnexableEntityUnion.type"
import type { Entity } from "./index"

export default function isBeingAnnexedBy (
  annexableEnt : Entity,
  unit : Entity
) : annexableEnt is AnnexableEntityUnion {
  return (annexableEnt as HasAnnexPoints).ap_ent_id === unit.id
}